




































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';

import { lccaStore } from '@/store/store';
import { states } from '@/lib/data/states';
import { createLccaValidations } from '@/modules/lcca/lib/validations';
import { getProbabilisticByName, getUserProbInputs } from '@/modules/lcca/lib/util';
import { BaseProbVariables } from '@/modules/lcca/interfaces/probabilistic';

Component.registerHooks(['validations']);

@Component({
  components: {
    PxNumberInput,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class LccaScenarioInfo extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;

  get scenario() {
    return lccaStore.currentScenario;
  }

  get scenarioImperial() {
    return lccaStore.currentImperial;
  }

  sync() {
    lccaStore.setCurrentScenario(this.scenario);
  }

  save() {
    this.sync();
    lccaStore.saveCurrentScenario();
  }


  get userProbInputs() {
    return getUserProbInputs(this.scenarioImperial);
  }

  get trafficProbabilisticInputs() {
    return getProbabilisticByName(this.scenario.probabilistic, BaseProbVariables.annualGrowthTraffic);
  }


  validations() {
    return createLccaValidations(this.scenarioImperial);
    // const validationObject = {
    //   scenario: {
    //     name: {
    //       required
    //     },
    //     analysisPeriodStart_yr: {
    //       required,
    //       minValue: minValue(new Date(Date.now()).getFullYear() - 100),
    //       maxValue: maxValue(new Date(Date.now()).getFullYear() + 100)
    //     },
    //     analysisPeriodLength_yrs: {
    //       required,
    //       minValue: minValue(1),
    //       maxValue: maxValue(100)
    //     },
    //     // state: {
    //     //   required
    //     // }
    //   }
    // };
    // return validationObject
  }

  stateOptions = states;
}

